const NewResourceStatistics = () =>
  import('@/views/main/wechatMgmt/newResourceStatistics/NewResourceStatistics.vue')
export default {
  path: '/main/wechatMgmt/newResourceStatistics',
  name: 'NewResourceStatistics',
  component: NewResourceStatistics
}
